export default __webpack_public_path__ + "static/media/flyer_image_icon_.07f4eb5a.png";